import { CareEnvironment, CarePhase } from '../appModel';

const { home, assistedLiving, fullCareFacility } = CareEnvironment;

export const CONSUMER_CARE_SETTINGS: readonly ConsumerCareSetting[] = [
  'mixed',
  'home',
  'assisted',
  'nursing',
];

export const DEFAULT_CONSUMER_CARE_SETTING: ConsumerCareSetting = 'mixed';

export const CONSUMER_CARE_SETTING_PLACEMENTS: Record<
  ConsumerCareSetting,
  Record<CarePhase, CareEnvironment>
> = {
  mixed: {
    [CarePhase.earlyCare]: home,
    [CarePhase.moderateCare]: assistedLiving,
    [CarePhase.fullCare]: fullCareFacility,
  },
  home: {
    [CarePhase.earlyCare]: home,
    [CarePhase.moderateCare]: home,
    [CarePhase.fullCare]: home,
  },
  assisted: {
    [CarePhase.earlyCare]: home,
    [CarePhase.moderateCare]: assistedLiving,
    [CarePhase.fullCare]: assistedLiving,
  },
  nursing: {
    [CarePhase.earlyCare]: home,
    [CarePhase.moderateCare]: home,
    [CarePhase.fullCare]: fullCareFacility,
  },
};

export function careEnvironmentSelectionsForSetting(
  setting: ConsumerCareSetting,
): CareEnvironmentSelections {
  return { ...CONSUMER_CARE_SETTING_PLACEMENTS[setting] };
}

export function careSettingFromEnvironments(
  environments: Partial<Record<CarePhase, CareEnvironment | null>>,
): ConsumerCareSetting | null {
  return (
    CONSUMER_CARE_SETTINGS.find(setting =>
      Object.entries(CONSUMER_CARE_SETTING_PLACEMENTS[setting]).every(
        ([phase, environment]) => environments[Number(phase) as CarePhase] === environment,
      ),
    ) ?? null
  );
}
